export default {
    'create-warehouse': 'Crear almacén',
    'edit-warehouse': 'Editar almacén',
    'warehouse-name': 'Nombre de almacén',
    notes: 'Notas',
    save: 'Guardar',
    cancel: 'Cancelar',

    'delete-the-warehouse': 'Eliminar almacén',
    'are-you-sure-you-want-to-delete-the-warehouse': '¿Estas seguro de eliminar almacén?',
    "create": "Crear",
    "are-you-sure": "¿Estás seguro?",
    "contain": "Contiene",
    "imported-materials": "Materiales importados de",
    "no-imported-materials": "Sin importar ningún material",
    "warehouse-data": "Datos del almacén",
    "import-materials-from-warehouse": "Importar materiales del almacén",
    "creating-warehouse": "Actualmente se está creando el almacén",
    "warehouse-created-successfully": "El almacén se creó con éxito <i class='fas fa-check primary--text mt-1 mx-1'></i>. Actualmente se están importando los materiales...",
    "link-materials": "Vincular materiales",
    "link-materials-alert": "Los materiales del nuevo almacén se vincularán automáticamente con todos los almacenes actualmente conectados. Esto significa que cualquier cambio en los materiales vinculados se aplicará a todos los almacenes conectados.",
    "search-and-select-material": "Buscar y seleccionar material",
    headers: {
        'no': 'Número',
        'warehouse-name': 'Nombre de almacén',
        'notes': 'Notas',
        'actions': 'Acciones',
    }
}